
/**
 * Slider Breakpoint
 *
 * @package felixkiesewetter-js/slider
 * @since 1.12.0
 * @author Felix Kiesewetter <info@felixkiesewetter.de>
 * @version 1.0.0
 * @lastModified 2024-11-26
 */
class SliderBreakpoint
{

    #active = false;

    onEnter;
    onLeave;
    options;
    minWidth;
    maxWidth;

    /**
     * Breakpoint constructor
     *
     * @param {int} minWidth
     * @param {int} maxWidth
     * @param {null|Object} options
     * @param {null|Function} onEnter
     * @param {null|Function} onLeave
     */
    constructor(
        minWidth = 0,
        maxWidth = Infinity,
        options = null,
        onEnter = null,
        onLeave = null,
    )
    {
        this.minWidth = minWidth;
        this.maxWidth = maxWidth;
        this.onEnter = onEnter;
        this.onLeave = onLeave;
        this.options = options;
        // TODO: Slider.addBreakpoint() method
    }

    /**
     * Check whether the breakpoint applies to given width
     *
     * @param {int} width
     * @returns {boolean}
     */
    applies(width)
    {
        return width >= this.minWidth && width <= this.maxWidth;
    }

    /**
     * Run breakpoint callback
     *
     * @param {Slider} parameters
     * @param parameters
     * @returns {Slider}
     */
    callback(callback, slider, ...parameters)
    {
        if (!this[callback] || Function !== this[callback].constructor) {
            return this;
        }
        this[callback](slider, this, ...parameters);
        return this;
    }

    /**
     * Public getter for the options object
     *
     * @returns {null|Object}
     */
    getOptions()
    {
        return this.options;
    }

    setActive(active)
    {
        this.#active = active;
        return this;
    }

    isActive()
    {
        return this.#active;
    }

}

export default SliderBreakpoint;